import { createElement, PropsWithChildren } from "react"

const Typography = ({variant, color = 'light', children, ...props}: TypographyProps) => {

    if (!children) {
        return <></>
    }

    const className = `block antialiased ${classNames[variant]} ${colors[color]} ${props.className || ''}`
    return createElement(variant, {...props, className}, children)
}

export const classNames = {
    h1: 'tracking-wide font-sans text-3xl leading-wide',
    h2: 'tracking-wide font-sans text-2xl leading-wide',
    h3: 'tracking-wide font-sans text-xl leading-wide',
    h4: 'tracking-normal font-sans text-l leading-snug',
    h5: 'tracking-normal font-sans text-m leading-snug',
    h6: 'tracking-normal font-sans text-m leading-snug',
    p: 'tracking-normal font-sans text-m leading-relaxed',
    span: 'tracking-normal font-sans text-xs leading-relaxed'
}

const colors = {
    light: 'text-white',
    dark: 'text-black',
    red: 'text-red-500'
}

export type TypographyProps = PropsWithChildren<{
    variant: TypographyVariant
    id?: string
    color?: TypographyColor
    className?: string
}>

export type TypographyVariant = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span'

export type TypographyColor = 'light' | 'dark' | 'red'

export default Typography
